import React from 'react';
import { Card,Col,Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

import { useState } from 'react';
import { getDashboard_supportServicesTable_Line } from 'functions/dashboard';
import { useEffect } from 'react';
import SupportServicesLineMonth from './support-services-line-month/AverageEnrollment';
import SupportServicesMonth from './support-services-month-table/SupportServicesMonth';
import moment from 'moment';
import SelectOption from 'components/select/SelectOption';


const SupportServicesMonthAll = ({fromDate, toDate, companyId}) => {

useEffect(()=>{
loadTableData_Date(fromDate, toDate, companyId)
}
,[fromDate, toDate, companyId])

const loadTableData_Date = async(fromDate, toDate, companyId)=>{
  try {

    const year=moment(fromDate).year();

  const data = {
    fromDate,
    toDate,
    year:year,
    type: 'year'
  , companyId: companyId ? companyId : null
  };  



  const token=localStorage.getItem('token');
 const tableDataO=await getDashboard_supportServicesTable_Line(data,token);
// console.log('taaaaa',tableDataO);

 if (tableDataO.recordsets && Array.isArray(tableDataO.recordsets)) {
   const transformedData = tableDataO.recordsets.flat().map(item => ({
     id: item.groupby,
     month:moment(fromDate).year()+' '+ item.groupby,
     totalSupportCalls: item.totalTickets,
     resolved: item.totalTicketsResolved,
     permanentlyResolved: item.totalTicketsPermenentlyResolved,
     temporaryResolved: item.totalTicketsTemporaryResolved,
     pending: item.totalTicketsPending
   }));

   setTableData(transformedData.filter(item => item.totalSupportCalls > 0));
 }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
  }

  const [yearsOps,setYearsOps]=useState(null);
  const [selectedYear,setSelectedYear]=useState((new Date()).getFullYear());
  
  useEffect(() => {
    loadDrpYears();
  }, []);



  const loadDrpYears = async () => {
    try{
      
      const options = [];
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= 2022; year--) {
        options.push({ value: year, text: year.toString() });
      }
      setYearsOps(options);

  }
  catch(err){
    console.log('Error',err);
  }
  };


   const [tableData,setTableData] =useState([
    {
      // id: 1,
      // date: '30.10.2023',
      // totalSupportCalls: 10,
      // resolved: 9,
      // permanentlyResolved: 7,
      // temporaryResolved: 2,
      // pending:1
    },
   
  ]);


  return (
    <Card className="overflow-hidden">
      <FalconCardHeader  
      title={`Monthly Summary Job Status (Values) | ${moment(fromDate).format('yyyy MMM DD hh:mm a')} - ${moment(toDate).format('yyyy MMM DD hh:mm a')}`}
       titleTag="h6" />
      <Card.Body className="p-0">
        {/* {JSON.stringify(tableData)} */}
        {/* <SupportServicesMonth data={tableData} /> */}
        <SupportServicesLineMonth data={tableData}  />
      </Card.Body>
      {/* <Card.Footer className="bg-light py-2">
        <Row className="flex-between-center g-0">
          <Col xs="auto">
          <div className="d-flex">
            <div className="d-flex" style={{marginRight:'30px'}}>
              <label
                htmlFor="yearDropdown"
                style={{ paddingTop: '10px', marginRight: '7px' }}
              >
                Year
              </label>
              <SelectOption
                id="yearDropdown"
                options={yearsOps}
                handleChange={e => {
                  setSelectedYear(e.target.value);
                }}
                selectedValue={selectedYear}
              />
            </div>
</div>

          </Col>
   
        </Row>
      </Card.Footer> */}
    </Card>
  );
};

export default SupportServicesMonthAll;
